import React from "react";
import Specifications from "./specifications/Specifications";
import Equipment from "./equipment/Equipment";
import ServiceHistory from "./servicehistory/ServiceHistory";
import { UscLabel } from "../../../../utils/labels";
import Text from "../../styles/atoms/Text";
import * as Styles from "./CarDetails.styles";

const CarDetails = (): JSX.Element => {
    return (
        <Styles.Wrapper>
            <Text tag="h2" variant="h4">
                <UscLabel label="uscPdpCarDetailsTitle" />
            </Text>
            <Specifications />
            <Equipment />
            <ServiceHistory />
        </Styles.Wrapper>
    );
};

export default CarDetails;
